module.exports = __webpack_public_path__ + "static/media/taiping.78f74143.png";